import { Attributes } from 'shared/types/product';

// export const getAttributeValue = (attributes: Attributes[], name: string) => {
//   return attributes?.find((attr) => attr?.name === name)?.value;
// };

export const getEstimatedDispatchDate = (leadTime: number) => {
  const today = new Date();
  today.setDate(today.getDate() + leadTime);
  // Format as DD/MM/YYYY
  const day = String(today.getDate())?.padStart(2, '0');
  const month = String(today.getMonth() + 1)?.padStart(2, '0');
  const year = today.getFullYear();
  return `${day}/${month}/${year}`;
};
